import _ from 'lodash';
import $ from 'jquery';
import PubSub from '../utils/PubSub';
import cx from 'classnames';
import RendererMessages from '../const/RendererMessages';
import FrameMessages from '../const/FrameMessages';
import {renderModes, cardFrameContainerId} from '../const/AugmentationConst';

export default class FramesCache {
  constructor() {
    this.frames = {};
    this.redirectCookies = {};

    this.handleFrameMessage = this.handleFrameMessage.bind(this);

    this.container = $(`#${cardFrameContainerId}`).first();
    if (!this.container.length) {
      this.container = $(`<div id="${cardFrameContainerId}" />`).appendTo('body');
    }
  }

  listenForRendererEvents() {
    PubSub.subscribe(RendererMessages.addCardFrame, (params) => {
      const {frameId, hasVideo, frameUrl, vucardStyle} = params;
      if (!this.frames[frameId]) {
        const frameClass = cx('vuCardFrame', `vuCardFrame--${vucardStyle}`, {'vuCardFrame--has-video': hasVideo});
        this.frames[frameId] = $(
          `<iframe class="${frameClass}"
                           style="display: none"
                           src="${frameUrl}"
                           id="vuCardFrame-${frameId}"
                           name="vuCardFrame"
                           scrolling="no"
                           frameborder="0"/>`)
          .appendTo(this.container)[0];
      }
    });

    PubSub.subscribe(RendererMessages.addAdFrame, (params) => {
      const {frameId, frameUrl, renderMode, adSize} = params;
      if (!this.frames[frameId]) {
        const frameClass = cx('vupAdFrame', `vupAdFrame--${renderMode}`);
        const useAdSize = renderMode === renderModes.iframeBottomBanner;
        const closePadding = 30;
        const sizeStyle = (useAdSize && adSize) ? `max-width: ${adSize.width + closePadding}px; height: ${adSize.height}px;` : '';
        const style = `display: block; ${sizeStyle}`;
        this.frames[frameId] = $(
          `<iframe class="${frameClass}"
                           style="${style}"
                           src="${frameUrl}"
                           id="vupAdFrame-${frameId}"
                           scrolling="no"
                           frameborder="0"/>`)
          .appendTo(this.container)[0];
      }
    });

    PubSub.subscribe(RendererMessages.displayFrame, (frameId) => {
      const iFrame = this.frames[frameId];
      if (iFrame) {
        this.postMessageToIframe(iFrame, {title: FrameMessages.setVisible}, '*');
        iFrame.style.display = 'block';
      }
    });

    PubSub.subscribe(RendererMessages.hideFrame, (frameId) => {
      this.handleIframeHide(frameId);
    });
  }

  handleIframeHide(frameId) {
    const iFrame = this.frames[frameId];
    if (iFrame) {
      this.postMessageToIframe(iFrame, {title: FrameMessages.setHidden}, '*');
      iFrame.style.display = 'none';
    }
  }

  listenForCardEvents() {
    window.addEventListener('message', this.handleFrameMessage, false);
  }

  handleFrameMessage(e) {
    const title = _.get(e, 'data.title');

    switch (title) {
      case FrameMessages.setRedirectState: {
        const {cookie, cardId} = e.data;
        this.redirectCookies[cardId] = cookie;
        break;
      }
      case FrameMessages.requestHide: {
        const {frameId} = e.data;
        this.handleIframeHide(frameId);
        PubSub.publish(RendererMessages.notifyFrameHidden, frameId);
        break;
      }
      default:
        break;
    }
  }

  getRedirectCookie(cardId) {
    return this.redirectCookies[cardId];
  }

  postMessageToIframe(iFrame, data, domain) {
    if (_.get(iFrame, 'contentWindow.postMessage')) {
      iFrame.contentWindow.postMessage(data, domain);
    }
  }

  deleteIframes() {
    // eslint-disable-next-line guard-for-in
    for (const frameId in this.frames) {
      const frame = this.frames[frameId];
      delete this.frames[frameId];
      $(frame).remove();
    }
  }
}
